<template>
  <div class="layout-page" element-loading-background="rgba(255,255,255, 0.8)">
    <header class="header">
      <TopNav />
      <!-- <HeaderSection /> -->
    </header>
    <section class="contaniner">
      <div class="pageLeft">
        <MenuList />
      </div>
      <div class="pageRight">
        <!-- <div class="breadcrumbBox">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: 'work' }"
              ><i class="el-icon-location"></i>当前位置：工作台</el-breadcrumb-item
            >
            <el-breadcrumb-item v-if="path&&path != 'work'">{{
              title
            }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div> -->
        <router-view />
      </div>
    </section>
    <Footer />
  </div>
</template>
<script>
import TopNav from "@/components/TopNav";
import HeaderSection from "@/views/financInstitutionPC/layout/header";
import Footer from "@/components/Footer";
import MenuList from "./components/menuList";

export default {
  components: { HeaderSection, Footer, MenuList,TopNav},
  data() {
    return {
      title: null,
      path: null,
    };
  },
  created() {
  },

  watch: {
    $route(to, from) {
      this.title = to.meta.title;
      this.path = to.name;
    },
  },
};
</script>

<style
  scoped
  lang="scss">
  #app{
    height:auto !important;
  }
.layout-page {
  width: 100%;
  min-height: 100%;
  height: 100%;
  background: #fafafa;
}
.header {
  width: 100%;
  min-width: 1650px;
  position: absolute;
  left: 0;
  top: 0;
  background: #fafafa;
  z-index: 999;
}

.contaniner {
  width: 100%;
  padding-top: 80px;
  min-height: calc(100vh - 160px);
  display: flex;
  justify-content: center;
  align-items: stretch;
  box-sizing: border-box;
  background: linear-gradient(to bottom, #EBF3FE 30%, #BADBFE 60%), linear-gradient(to right, #ACD6FC, #BADBFE, #BFD9FE, #CDCEFC);
}
.pageLeft {
  width: 200px;
  flex-shrink: 0;
  padding-top: 20px;
  padding-bottom: 100px;
  margin-right: 20px;
  display: flex;
  flex-direction: column;

  ::v-deep .page-left {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  ::v-deep .menuBox {
    flex: 1;
  }
}
.pageRight {
  flex: 1;
  max-width: 1280px;
  padding-top: 20px;
  padding-bottom: 100px;
  .breadcrumbBox {
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 10px;
    margin-bottom: 20px;
  }
}
.right-content {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  // padding-top: 34px;
  box-sizing: border-box;
  position: relative;
}
.breadcrumb {
  padding: 6px 0;
  position: absolute;
  top: 0;
  left: 0;
  margin-left: 15px;
  margin-top: 5px;
  display: flex;
  align-items: center;
  .el-breadcrumb {
    width: 100%;
  }
  ::v-deep.el-breadcrumb__item:nth-of-type(1) {
    .el-breadcrumb__inner {
      font-weight: 700 !important;
      color: #000;
    }
  }
}

.main-card {
  margin: 0 15px 0 15px;
  height: 100%;
  width: calc(100% - 30px);
  box-sizing: border-box;
  padding: 10px 0;
}
</style>